"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combinePaths = void 0;
exports.combinePaths = function (a, b) {
    // Normalize all path seperators
    a = a.replace(/\\/g, "/");
    b = b.replace(/\\/g, "/");
    // Append a seperator if one doesn't exist
    if (a[a.length - 1] !== "/") {
        a += "/";
    }
    // Remove any leading seperators from
    while (b[0] === "/" || b[0] === ".") {
        b = b.substr(1);
    }
    return a + b;
};
//# sourceMappingURL=combine-paths.js.map